export const storiesCategory = 'Editing in Maps/';
